import React, { Component } from "react";
import Form from "react-validation/build/form";

import CheckButton from "react-validation/build/button";

import history from "./history";

import AuthService from "../../../services/login/auth.service";
import MensajeLogin from "../../generico/Login/MensajeLogin";
import $ from "jquery";
import UAParserJS from "ua-parser-js";
import ConfigService from "../../../services/configuracion/ConfigService";
import { fontSize, lineHeight, textAlign } from "@mui/system";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";
import SoftTokenService from "../../../services/softToken/SoftTokenService";
import { MENSAJE } from "../../generico/utils/Constantes";
const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        Requerido
      </div>
    );
  }
};

const body = document.body;
const lightTheme = "light";
const darkTheme = "dark";

const TOKEN_STATE_RESPONSE = {
  CONFIRM: "CONFIRM",
  CANCEL: "CANCEL",
  NO_RESPONSE: "NO_RESPONSE"
};

const METODO_LOGIN_RESPONSE = {
  VALIDAR_CREDENCIALES: "VALIDAR_CREDENCIALES",
  OBTENER_ACCESS_TOKEN: "OBTENER_ACCESS_TOKEN",
  NO_INICIAR: "NO_INICIAR"
};

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.onChangeTipo = this.onChangeTipo.bind(this);
    this.onChangeNumero = this.onChangeNumero.bind(this);
    this.onChangeCedula = this.onChangeCedula.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.clientInfo = this.clientInfo.bind(this);
    //sessionStorage.clear();
    this.state = {
      tipo: "",
      numero: "",
      cedula: "",
      password: "",
      loading: false,
      isReset: AuthService.getIsReset(),
      message: "",
      tipoMessage: "",
      infoClient: undefined,
      theme: "light",
      hidden: true
    };

    this.toggleShow = this.toggleShow.bind(this);
  }

  componentDidMount() {
    sessionStorage.removeItem("pinTransaccional");
    sessionStorage.removeItem("mostrarAviso");
    sessionStorage.removeItem("user");
    $("body").addClass("image_background");
    this.clientInfo();

    // obtener tema actual
    if (localStorage) {
      let themeStorage = localStorage.getItem("theme");
      this.setState({ theme: themeStorage });
    }

  }

  async clientInfo() {
    var parserUA = new UAParserJS.UAParser();
    var resultUA = parserUA.getResult();
    //console.log(resultUA.browser);
    parserUA.setUA(navigator.userAgent);
    var info = {
      marcaNavegador: resultUA.browser.name,
      modeloVersion: resultUA.browser.version,
      so:
        resultUA.os.name +
        " " +
        resultUA.os.version +
        "; " +
        resultUA.cpu.architecture,
    };
    fetch("https://api.ipify.org/?format=json")
      .then((response) => response.json())
      .then((data) => {
        info.ip = data.ip;
        //console.log("LOGIN IP: ", info.ip);
      })
      .catch(error => {
        console.log(error);
      });

    const location = "geolocation" in navigator;
    if (location) {
      navigator.geolocation.getCurrentPosition((position) => {
        info.latitud = position.coords.latitude;
        info.longitud = position.coords.longitude;
      });
    } else {
      info.latitud = undefined;
      info.longitud = undefined;
    }

    this.setState({ infoClient: info });
  }
  toggleShow() {
    this.setState({ hidden: !this.state.hidden });
  }

  onChangeTipo(event) {
    this.setState({
      tipo: event.target.value,
    });
  }

  onChangeNumero(e) {
    this.setState({
      numero: e.target.value.trim(),

    });
  }

  onChangeCedula(e) {
    this.setState({
      cedula: e.target.value.trim(),
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value,
    });
  }

  // metodo para obtener el siguiente paso para login
  async consultarMetodoLogin(nroCedulaSocio) {

    let metodoLoginResponse = await SoftTokenService.obtenerMetodoLogin(nroCedulaSocio);

    const { codigo, mensaje, datos } = metodoLoginResponse.data;

    // si la persona todavia no tiene un token
    if (codigo === 1) {

      this.btn.removeAttribute("disabled");
      this.setState({
        loading: false,
        tipoMessage: "ERROR",
        message: mensaje
      });
    }

    return datos;

  }

  // consultar estado challengeToken 
  async verificarChallengeToken(challengeToken) {

    let tiempoInicial = new Date();

    return new Promise(async (resolve, reject) => {

      try {

        this.setState({
          tipoMessage: "ENTRUST",
          message: "Debe confirmar su acceso desde su celular"
        });

        // consultar cada 2 segundos por el estado del challenge
        let contadorReintentos = 0;
        let timer = setInterval(async () => {
          console.log("contadorReintentos: " + contadorReintentos++);

          try {

            let tokenStateResp = await SoftTokenService.getTokenPushState(challengeToken, this.state.cedula);

            const { codigo, datos: { status } } = tokenStateResp.data;

            if (codigo == 0) {

              let tiempoAhora = new Date();
              let segundosTranscurridos = (tiempoAhora - tiempoInicial) / 1000;
              console.log("tiempo transcurrido: " + segundosTranscurridos);

              // permite acceso
              if (status == TOKEN_STATE_RESPONSE.CONFIRM) {
                clearInterval(timer);
                resolve(status);

              } else if (status == TOKEN_STATE_RESPONSE.CANCEL) { // cancela el acceso
                clearInterval(timer);
                this.btn.removeAttribute("disabled");
                this.setState({
                  loading: false,
                  tipoMessage: "ERROR",
                  message: "Ha denegado el acceso desde su celular"
                });

                resolve(status);

              } else if (status == TOKEN_STATE_RESPONSE.NO_RESPONSE && segundosTranscurridos > 60) { // cancela el acceso
                clearInterval(timer);
                this.btn.removeAttribute("disabled");
                this.setState({
                  loading: false,
                  tipoMessage: "ERROR",
                  message: "Ha superado el tiempo maximo de espera a una confirmacion de acceso"
                });

                resolve(status);
              }
            }

          } catch (error) {
            console.log("error validacion de estado challenge token")
            console.log(error)
            clearInterval(timer);
            reject(error);
          }

        }, 2000);

      } catch (error) {
        this.btn.removeAttribute("disabled");
        const resMessage = MENSAJE.ERROR_INESPERADO;
        this.setState({
          loading: false,
          tipoMessage: "ERROR",
          message: resMessage
        });
      }

    })

  }

  // 
  async obtenerAccessToken({
    imeiIp,
    cuenta,
    cedulaIdentidad,
    cambiar,
    ultimoAcceso,
    canal,
    nombreCompleto,
    identificador,
    jti,
    tokenChallenge,
    fingerprint,
    password,
    infoClient,
    tipoCuenta,
    username,
    numeroSocio
  }) {

    let tiempoInicial = new Date();

    return new Promise(async (resolve) => {

      this.setState({
        tipoMessage: "ENTRUST",
        message: "Debe confirmar su acceso desde su celular"
      });

      // consultar cada 2 segundos por el estado del challenge
      let contadorReintentos = 0;
      let timer = setInterval(async () => {

        // console.log("contadorReintentos: " + contadorReintentos++);

        let tiempoAhora = new Date();
        let segundosTranscurridos = (tiempoAhora - tiempoInicial) / 1000;
        // console.log("tiempo transcurrido: " + segundosTranscurridos);

        // cancela el acceso
        if (segundosTranscurridos > 60) {
          clearInterval(timer);
          this.btn.removeAttribute("disabled");
          this.setState({
            loading: false,
            tipoMessage: "ERROR",
            message: "Ha superado el tiempo maximo de espera a una confirmacion de acceso"
          });

          resolve({ error: "NO_RESPONSE" });
        }

        try {

          // obtener access token con validacion de challenge token
          const accessTokenRespuesta = await AuthService.getAccessToken({
            imeiIp,
            cuenta,
            cedulaIdentidad,
            cambiar,
            ultimoAcceso,
            canal,
            nombreCompleto,
            identificador,
            jti,
            tokenChallenge,
            fingerprint,
            password,
            infoClient,
            tipoCuenta,
            username,
            numeroSocio
          });

          clearInterval(timer);
          resolve(accessTokenRespuesta);

        } catch (err) {
          // console.log("error validacion de estado challenge token")
          // console.log(err);

          const { error, error_description } = err.response.data;

          if (error !== TOKEN_STATE_RESPONSE.NO_RESPONSE) {
            clearInterval(timer);
            this.btn.removeAttribute("disabled");
            this.setState({
              loading: false,
              tipoMessage: "ERROR",
              message: error === TOKEN_STATE_RESPONSE.CANCEL ? "Ha denegado el acceso desde su celular" : error_description
            });
            resolve({ error, error_description });
          }

        }

      }, 2000);

    });

  }

  async configurarAccesoLogin(authRespuesta) {

    const urlResponse = await ConfigService.getAccess(authRespuesta.data.access_token);

    //cargar las url habilitadas
    sessionStorage.setItem("menu", JSON.stringify(urlResponse.data.datos));

    sessionStorage.setItem("user", JSON.stringify(authRespuesta.data));
    sessionStorage.setItem("cambio", authRespuesta.data.cambiar);
    sessionStorage.setItem("cedula", authRespuesta.data.cedulaIdentidad);
    sessionStorage.setItem("temporal", this.state.password);

    await AuthService.loadSocio(authRespuesta.data.access_token);
    // window.ineum('user', this.state.numero);

    if (authRespuesta.data.cambiar === "N") {

      if (this.state.isReset === "S") {
        sessionStorage.removeItem("reset");
      }

      try {

        const response = await AuthService.debeCambiarPinTransaccional();

        var jsonData = JSON.parse(response);
        //console.log("Debe CAMBIAR")
        //console.log(jsonData)
        sessionStorage.setItem('estadoPinTransaccional',jsonData?.estadoPin);
        if (jsonData.cambiar === "S") {
          // sessionStorage.removeItem('cedula')
          sessionStorage.removeItem("temporal");
          sessionStorage.setItem("pinTransaccional", "S");
          //history.push("/pinTransaccional");
          history.push(ConfigService.getPathByName("pinTransaccional")?.url);
          window.location.reload();
        } else {
          sessionStorage.removeItem("cedula");
          sessionStorage.removeItem("temporal");
          sessionStorage.setItem("pinTransaccional", "N");

          history.push(ConfigService.getPathByName("resumenGeneralSocio")?.url);
          window.location.reload();
        }

      } catch (error) {
        //// Habilita boton
        this.btn.removeAttribute("disabled");
        //console.log("Error aca");
        const resMessage = error.response;
        this.setState({
          loading: false,
          tipoMessage: "ERROR",
          message: resMessage,
        });
      }

    }

  }

  // verificar soft token -> verificar credenciales -> iniciar challenge -> obtener accessToken
  async handleLogin(e) {
    //// bloquea boton
    this.btn.setAttribute("disabled", "disabled");
    e.preventDefault();

    this.setState({
      message: "Verificando acceso",
      tipoMessage: "ENTRUST",
      loading: true,
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {

      try {

        // obtener el siguiente paso para el login
        const metodoLoginResponse = await this.consultarMetodoLogin(this.state.cedula);

        // saber si se valida las credenciales o directamente se obtiene el access_token
        if (metodoLoginResponse === METODO_LOGIN_RESPONSE.VALIDAR_CREDENCIALES) {
          sessionStorage.setItem("tieneToken", "S");

          const fingerprint = SoftTokenService.getDeviceFingerprint();

          // verificar credenciales de socio
          const validarCredencialesRespuesta = await AuthService.validarCredenciales(
            this.state.cedula,
            this.state.numero,
            this.state.password,
            this.state.tipo,
            this.state.infoClient,
            fingerprint);

          const responseAccessToken = await this.obtenerAccessToken({
            ...validarCredencialesRespuesta.data,
            fingerprint,
            password: this.state.password,
            infoClient: this.state.infoClient,
            username: this.state.cedula
          });

          if (!responseAccessToken.error) {
            // luego de obtener el accessToken, obtener las configuraciones
            await this.configurarAccesoLogin(responseAccessToken);
          }

          // metodo anterior, se llama a getTokenStatePush, y luego a oauth/token

          // const {
          //   imeiIP,
          //   numeroSocio,
          //   cedulaIdentidad,
          //   cambiar,
          //   ultimoAcceso,
          //   canal,
          //   nombreCompleto,
          //   identificador,
          //   jti,
          //   tokenChallenge,
          // } = validarCredencialesRespuesta.data;

          // // controles softoken
          // const verificarTokenRespuesta = await this.verificarChallengeToken(tokenChallenge);

          // console.log({ verificarTokenRespuesta });

          // if (verificarTokenRespuesta === TOKEN_STATE_RESPONSE.CONFIRM) {

          //   // obtener access token con validacion de challenge token
          //   const accessTokenRespuesta = await AuthService.getAccessToken({
          //     imeiIP,
          //     numeroSocio,
          //     cedulaIdentidad,
          //     cambiar,
          //     ultimoAcceso,
          //     canal,
          //     nombreCompleto,
          //     identificador,
          //     jti,
          //     tokenChallenge,
          //     fingerprint
          //   });

          //   // luego de obtener el accessToken, obtener las configuraciones
          //   await this.configurarAccesoLogin(accessTokenRespuesta);

          // }

        } else if (metodoLoginResponse === METODO_LOGIN_RESPONSE.OBTENER_ACCESS_TOKEN) {

          sessionStorage.setItem("tieneToken", "N");

          // obtener access token con login
          const loginRespuesta = await AuthService.login(
            this.state.cedula,
            this.state.numero,
            this.state.password,
            this.state.tipo,
            this.state.infoClient);

          await this.configurarAccesoLogin(loginRespuesta);

        }

      } catch (error) {

        sessionStorage.clear();

        //// Habilita boton
        this.btn.removeAttribute("disabled");
        var resMessage = "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste."
        if (error.response != null && error.response.status !== 401 && error.response.status !== 500) {
          resMessage = error.response.data.error_description || error.response.data.description;
        }

        if (error.response != null && (error.response.data?.error === "-2" || error.response.data?.errorCode === "-2")) {
          sessionStorage.setItem("cedula", this.state.cedula);
          sessionStorage.setItem("temporal", this.state.password);
          history.push("/pinAcceso");
          window.location.reload();
        }

        this.setState({
          loading: false,
          tipoMessage: "ERROR",
          message: resMessage,
        });

      }

    } else {
      this.setState({
        loading: false,
      });
    }
  }


  render() {

    if (this.state.theme === lightTheme || this.state.theme === darkTheme) {
      body.classList.add(this.state.theme);
    } else {
      body.classList.add(lightTheme);
    }

    return (
      <div
        className="row margentab"

      >
        <div
          className="col-md-12"
          style={{ paddingRight: 0 }}
        >
          <div>
            <div
              className="card-body"
              style={{
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 8,
              }}
            >
              <div className="row">

                <div
                  className="col-xxl-8 col-lg-8 col-md-12 img-login"
                  style={{
                    borderRadius: "0 0 14% 0",
                    paddingTop: 120,
                    paddingBottom: 100,
                    paddingLeft: 30,
                    paddingRight: 15,
                  }}
                >
                  {/* /.login-logo */}
                  <div className="login-logo">
                    <div className="logo">
                      <img
                        className="responsive-img"
                        style={{ width: "40%", marginBottom: 10, marginTop: -60 }}
                        src="dist/img/logo-cu-nuevo.png"
                      />
                    </div>

                    <Form
                      onSubmit={this.handleLogin}
                      ref={(c) => {
                        this.form = c;
                      }}
                    >
                      <div className=" col-lg-8 col-md-12" data-tip data-for="registerTip" style={{ textAlign: "right", color: "#EAAC24", fontSize: "18px" }}>
                        <FontAwesomeIcon icon={faExclamationCircle} /> Aviso
                      </div>
                      <div className="col-md-5">
                        <ReactTooltip id="registerTip" effect="solid">
                          <div className="col-md-12">
                            Para habilitar este servicio debe acudir a Casa Matriz o a
                            una de las sucursales de la Cooperativa, el mismo es sin
                            costo. Recuerde que la Clave es exclusivamente para su uso
                            personal, y que la misma sustituye a su firma, siendo de su
                            entera responsabilidad el uso de la misma. No la divulgue.
                            Tenga presente que la <strong> UNIVERSITARIA Ltda. </strong> nunca
                            solicitará vía telefónica o por email datos personales,
                            número de cuenta, número de tarjeta de crédito, contraseñas
                            o cualquier otra información confidencial. Proteja la
                            información de sus cuentas, una vez que haya finalizado sus
                            operaciones, cierre el navegador.</div>
                        </ReactTooltip>
                      </div>

                      <div className="col-lg-7 col-md-12 input-group" style={{ margin: "0 5rem", marginBottom: "1rem" }}>
                        <div className="col-12">
                          <p className="texto-login">Tipo de cuenta</p>
                        </div>
                        <select
                          required="required"
                          className="custom-select select-login"
                          name="tipo"
                          onChange={this.onChangeTipo}
                        >
                          <option value="">Seleccione un Tipo</option>
                          <option value="K">Número de Socio</option>
                          <option value="C">Cuenta de ahorro</option>
                          <option value="TJ">Tarjeta de Crédito</option>


                        </select>
                      </div>
                      <div className="col-lg-7 col-md-12 input-group" style={{ margin: "0 5rem", marginBottom: "1rem" }}>
                        <div className="col-12">
                          <p className="texto-login">Número</p>
                        </div>
                        <input
                          type="number"
                          required="required"
                          className="form-control form-login"
                          name="numero"
                          value={this.state.numero}
                          onChange={this.onChangeNumero}
                          placeholder="Número"
                        />
                        {/* <div className="input-group-append">
                          <div className="input-group-text">
                            <span className="fas fa-hashtag"></span>
                          </div>
                        </div> */}
                      </div>
                      <div className="col-lg-7 col-md-12 input-group" style={{ margin: "0 5rem", marginBottom: "1rem" }}>
                        <div className="col-12">
                          <p className="texto-login">Cédula</p>
                        </div>
                        <input
                          type="number"
                          required="required"
                          className="form-control form-login"
                          name="cedula"
                          value={this.state.cedula}
                          onChange={this.onChangeCedula}
                          validations={[required]}
                          placeholder="Cédula de Identidad"
                        />
                        {/* <div className="input-group-append">
                          <div
                            className="input-group-text"
                            style={{ paddingLeft: 10, paddingRight: 10 }}
                          >
                            <span className="fas fa-address-card"></span>
                          </div>
                        </div> */}
                      </div>
                      <div className="col-lg-7 col-md-12 input-group" style={{ margin: "0 5rem", marginBottom: "1rem" }}>
                        <div className="col-12">
                          <p className="texto-login">Contraseña</p>
                        </div>
                        <input
                          required="required"
                          type={this.state.hidden ? 'password' : 'text'}
                          className="form-control form-login"
                          name="password"
                          value={this.state.password}
                          onChange={this.onChangePassword}
                          validations={[required]}
                          placeholder="Clave"
                        />
                        <div className="eyepass">
                          <FontAwesomeIcon className="eyp" onClick={this.toggleShow} icon={this.state.hidden ? faEyeSlash  : faEye} style={{ fontSize: '1.5rem' }} />
                        </div>

                        {/* <div className="input-group-append">
                          <div className="input-group-text">
                            <span className="fas fa-lock"></span>
                          </div>
                        </div> */}
                      </div>
                      <div className="row">
                        {/*<div className="col-6">
                          <a
                            href="https://www.cu.coop.py/index.php?option=com_rsform&view=rsform&formId=28"
                            className="btn btn-primary btn-block btn-cu-secundary btn-sombra"
                          >
                            ASOCIATE
                          </a>
                        </div>*/}
                        <div className="col-lg-7 col-md-12 btn-align">
                          <button ref={btn => { this.btn = btn; }}
                            type="submit"
                            className="btn btn-cu-primary-login"
                          >
                            {this.state.loading && (
                              <span className="spinner-border spinner-border-sm"></span>
                            )}
                            INGRESAR
                          </button>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-lg-7 col-md-12 input-group" style={{ margin: "0 5rem", marginRight: "0" }}>
                            {this.state.message && (
                              <MensajeLogin
                                tipo={this.state.tipoMessage}
                                mensaje={this.state.message}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      <CheckButton
                        style={{ display: "none" }}
                        ref={(c) => {
                          this.checkBtn = c;
                        }}
                      />
                      {this.state.isReset === "S" && (
                        <MensajeLogin
                          tipo="INFO"
                          mensaje="Debe loguearse con su nueva contraseña"
                        />
                      )}
                    </Form>
                  </div>

                </div>
                {/* <div
                  className="col-xxl-4 col-lg-5 col-md-6">
                   <h2 className="socios">#sociodigitales</h2>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {/*<div class="col-md-12">
                        <footer class="main-footer">
                            Para habilitar este servicio debe acudir a Casa Matriz o a una de las sucursales de la Cooperativa, el mismo es sin costo.
                            Recuerde que la Clave es exclusivamente para su uso personal, y que la misma sustituye a su firma, siendo de su entera responsabilidad el uso de la misma. No la divulgue.
                            Tenga presente que la Cooperativa Universitaria Ltda. nunca solicitará vía telefónica o por email datos personales, número de cuenta, número de tarjeta de crédito, contraseñas o cualquier otra información confidencial. Proteja la información de sus cuentas, una vez que haya finalizado sus operaciones, cierre el navegador.
                        </footer>
                        </div>*/}
      </div>
    );
  }
}
